export default __webpack_public_path__ + "static/media/664.19e6686c.png";